export default angular.module('timeoutHelpers', []);
